export default __webpack_public_path__ + "static/media/czechgo-screenshot-05.d3c4dcca.png";